import {
    GET_DEPOSIT_LEDGER_ALL,
    GET_DEPOSIT_LEDGER_USER,
    DEPOSIT_LEDGER_LOADING
} from '../actions/types';

const initialState = {
    depositLedger: undefined,
    loading: true,
    pageList: [],
    activePage: 0,
    pages: 0
};

export default (state = initialState, { type, payload }) => {
    switch (type) {
        case DEPOSIT_LEDGER_LOADING:
            return {
                ...state,
                loading: true
            };

        case GET_DEPOSIT_LEDGER_ALL:
        case GET_DEPOSIT_LEDGER_USER:
            return {
                ...state,
                depositLedger: payload.depositLedger,
                pages: payload.pages || 0,
                pageList: payload.pageList || [],
                activePage: payload.activePage || 0,
                loading: false
            };

        default:
            return state;
    }
}; 